import { useEffect, useState } from "react"

import { useDispatch, useSelector } from "react-redux"

import { configureDate, serializeData } from "../../../../../Utils/utils"
import ReferralActions from "../../../reducer"
import ChartModal from "../../ChartModal/ChartModal"

const AlertsChartModal = ({ open, close, baId }) => {
  const dispatch = useDispatch()
  const { adminTableAlertsChart, adminTableAlertsChartFetching } = useSelector(
    (state) => state.referrals
  )

  const [period, setPeriod] = useState("7 days")

  const getAlertsChart = (query, baId) => {
    dispatch(
      ReferralActions.getAdminTableAlertsChartRequest({
        business_account_id: baId,
        params: {
          ...query
        }
      })
    )
  }

  useEffect(() => {
    let periodTimestamps
    if (period?.type === "custom") {
      periodTimestamps = configureDate("custom", period.period)
    } else periodTimestamps = configureDate(period)
    const period_query = serializeData(periodTimestamps)
    if (baId && open) {
      getAlertsChart(period_query, baId)
    }
  }, [baId, open, period])

  return (
    <ChartModal
      open={open}
      close={close}
      data={adminTableAlertsChart}
      dataType="count"
      title="Alerts"
      loading={adminTableAlertsChartFetching}
      period={period}
      setPeriod={setPeriod}
      total={adminTableAlertsChart?.total_value ?? 0}
      isAlertsChart
    />
  )
}

export default AlertsChartModal
